import { render, staticRenderFns } from "./ProjectDetailsRow.vue?vue&type=template&id=764580d3&scoped=true"
import script from "./ProjectDetailsRow.vue?vue&type=script&lang=js"
export * from "./ProjectDetailsRow.vue?vue&type=script&lang=js"
import style0 from "./ProjectDetailsRow.vue?vue&type=style&index=0&id=764580d3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "764580d3",
  null
  
)

export default component.exports